import React, { useEffect, useState } from "react";
import { ResourceCodeEnums } from "@/api/dmp_common/interface";
import { useRouter } from "next/router";

import Home from "./home";

const skeletonMap = {
  [ResourceCodeEnums.HOME]: <Home />,
};

const DmpSkeleton = () => {
  const router = useRouter()
  return skeletonMap[router.pathname.replace(/^\//, "")] || null;
};
export default DmpSkeleton;
